import {
  DOCTOR_INFORMATION_SUCCESS,
  DOCTOR_MEDICAL_LICENCE_SUCCESS,
  SET_DOCTOR_PROFILE_LOADING,
  SET_DOCTOR_PROFILE,
  GET_DOCTOR_PROFILE_LOADING,
  SET_DOCTOR_ERROR,
  SET_PROVIDER_STATUS,
  SET_VALIDATION_PROVIDER_EMAIL,
  SET_ORIGINAL_PROFILE,
  MODIFY_PROFILE
} from '../mutation-types'
import * as ehrService from '@/services/ehr-api.service'
import * as providerService from '@/services/providers-api.service'
import authService from '@/services/auth.service'
import { getProviderProfile } from '@/config/profile-information'
import router from '@/router'
import { camelizeKeys, decamelizeKeys } from 'humps'

const setDoctorInformation = async ({ commit }, doctor) => {
  const response = await ehrService.getDoctorInformation(doctor)
  const data = camelizeKeys(response.data)
  commit(DOCTOR_INFORMATION_SUCCESS, data)
}

const medicalLicense = async ({ commit, state }) => {
  await ehrService.validateMedicalLicence(state.doctorInformation)
  commit(DOCTOR_MEDICAL_LICENCE_SUCCESS)
}

const getDoctorProfile = async ({ commit }, doctor) => {
  commit(SET_DOCTOR_PROFILE_LOADING, true)  
  try {
    const response = await providerService.getDoctorInformation(doctor);
    const data = camelizeKeys(response.data)

    const providerDataDTO = getProviderProfile(data)
    commit(SET_ORIGINAL_PROFILE, data)
    commit(SET_DOCTOR_PROFILE, providerDataDTO)
    commit(SET_DOCTOR_PROFILE_LOADING, false)
  } catch (error) {
    commit(SET_DOCTOR_PROFILE_LOADING, false)
  }
}

const sendOtp = async ({ commit }, payload) => {
  commit(GET_DOCTOR_PROFILE_LOADING, true)
  try {
    await authService.sendOtp(payload);
    commit(GET_DOCTOR_PROFILE_LOADING, false)
    commit(SET_DOCTOR_ERROR, { alert: true, alertType: 'success', message: `Se envió el código de consulta a ${payload.emailAddress}` })
    setTimeout(() => { 
      commit(SET_DOCTOR_ERROR, {})
    }, 6000)
  } catch (error) {
    const { response } = error;
    commit(SET_DOCTOR_ERROR, {alert: true, alertType: 'error', message: response && response.data.message})
  }
}

const validateOtp = async ({ commit }, payload) => {
  commit(GET_DOCTOR_PROFILE_LOADING, true)
  try {
    const response = await authService.validateOtp(payload);
    commit(GET_DOCTOR_PROFILE_LOADING, false)
    commit(SET_VALIDATION_PROVIDER_EMAIL, { email: payload.emailAddress, valid: true })
    return response.data
  } catch (error) {
    const { response } = error;
    commit(SET_VALIDATION_PROVIDER_EMAIL, { email: payload.emailAddress, valid: false })
    commit(SET_DOCTOR_ERROR, { alert: true, alertType: 'error', message: response && response.data.message })
    throw error
  }
}

const getStatusRegistrationRequest = async ({ commit }, payload) => {
  commit(GET_DOCTOR_PROFILE_LOADING, true)
  try {
    const response = await providerService.getProviderRegistrationRequest(payload);
    const data = camelizeKeys(response.data)

    const providerDataDTO = getProviderProfile(data)
    commit(SET_PROVIDER_STATUS, data)
    commit(SET_DOCTOR_PROFILE, providerDataDTO)
    commit(GET_DOCTOR_PROFILE_LOADING, false)
  } catch (error) {
    const { response } = error;
    commit(SET_DOCTOR_ERROR, { alert: true, alertType: 'error', message: response && response.data.message })
    router.push('/login')
  }
}

const setDoctorError = ({ commit }, payload) => {
  commit(SET_DOCTOR_ERROR, payload)
}

const modifyProviderProfile = ({ commit }, payload) => {
  commit(MODIFY_PROFILE, payload)
}

const updateProviderProfile = async ({ commit, state, rootState }) => {
  commit(GET_DOCTOR_PROFILE_LOADING, true)
  const providerSlug = rootState.auth.tokenExtensions.providerSlug;
  const { givenNames, surnames, rfc: taxIdentificationNumber, email: emailAddress, profilePicture, profilePictureName  } = state.modifyProfile
  const payload = decamelizeKeys({ givenNames, surnames, taxIdentificationNumber, emailAddress, profilePicture, profilePictureName })
  payload['additional_properties'] = state.modifyProfile.additionalProperties

  try {
    const response = await providerService.updateProviderProfile(providerSlug, payload)
    const data = camelizeKeys(response.data)
    const providerDataDTO = getProviderProfile(data)
    commit(SET_ORIGINAL_PROFILE, data)
    commit(SET_DOCTOR_PROFILE, providerDataDTO)
    commit(GET_DOCTOR_PROFILE_LOADING, false)
    router.push('/profile')
  } catch (error) {
     const { response } = error;
    commit(SET_DOCTOR_ERROR, { alert: true, alertType: 'error', message: response && response.data.message })
    commit(GET_DOCTOR_PROFILE_LOADING, false)
  }
  
}

export default {
  setDoctorInformation,
  medicalLicense,
  getDoctorProfile,
  sendOtp,
  validateOtp,
  getStatusRegistrationRequest,
  setDoctorError,
  modifyProviderProfile,
  updateProviderProfile
}
